"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.Radio = void 0;
require("./Radio.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Radio component
 *
 * @method
 * @param { RadioProps } props
 * @returns Radio
 */

const Radio = props => {
  const {
    ariaDescribedBy,
    ariaLabel,
    children,
    id,
    inputRef,
    checked = defaultProps.checked,
    defaultChecked,
    disabled = defaultProps.disabled,
    isFullyClickable = defaultProps.isFullyClickable,
    name,
    title,
    count,
    screenReaderText,
    tabIndex,
    onChange,
    ...other
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-Radio', {
    'pal-c-Radio--checked': checked,
    'pal-c-Radio--disabled': disabled,
    'pal-c-Radio--fullyClickable': isFullyClickable
  });
  const hasDefaultContent = title || count || screenReaderText;
  const hasLabel = hasDefaultContent || children;
  const renderRadioDefaultContent = () => {
    if (!hasDefaultContent) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-Radio__content--default"
    }, title && /*#__PURE__*/_react.default.createElement(_Text.default, {
      htmlTag: "span",
      textStyle: "body-lg",
      textColor: disabled ? 'default-disabled' : 'default'
    }, title), count && /*#__PURE__*/_react.default.createElement(_Text.default, {
      htmlTag: "span",
      textStyle: "label-sm",
      textColor: disabled ? 'default-disabled' : 'xsubtle'
    }, count), screenReaderText && /*#__PURE__*/_react.default.createElement(_Text.default, {
      htmlTag: "span",
      screenReader: true
    }, screenReaderText));
  };

  // Callback function triggered on radio input
  const handleChange = e => {
    if (!disabled) {
      onChange?.(e);
    }
  };
  const inputElement = /*#__PURE__*/_react.default.createElement("input", _extends({
    ref: inputRef,
    name: name,
    id: id,
    type: "radio",
    onChange: handleChange,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    tabIndex: tabIndex,
    "aria-describedby": ariaDescribedBy,
    "aria-label": !hasLabel ? ariaLabel : undefined
  }, other));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, isFullyClickable && /*#__PURE__*/_react.default.createElement("label", {
    id: `${id}_label`,
    htmlFor: id,
    className: "pal-c-Radio__label"
  }, inputElement, renderRadioDefaultContent(), children), !isFullyClickable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("label", {
    id: `${id}_label`,
    htmlFor: id,
    className: "pal-c-Radio__label"
  }, inputElement, renderRadioDefaultContent()), children));
};

/**
 * Property type definitions
 * @typedef RadioProps
 * @type {object}
 * @property {string} ariaDescribedBy - Sets aria-describedBy for the input.
 * @property {string} ariaLabel - Sets aria-label for the input.
 * @property {node} children - Custom children for the Radio
 * @property {string} id - Sets id for the radio input
 * @property {any} inputRef - Reference to the radio
 * @property {boolean} checked - Sets checked state of the radio
 * @property {boolean} defaultChecked - Sets defaultChecked state of the radio
 * @property {boolean} disabled - Sets the disabled state of the radio
 * @property {boolean} isFullyClickable - Sets if clicking on the custom children checks the radio
 * @property {string} name - Sets name for the radio input
 * @property {string} title - Sets the title text of the radio
 * @property {number} count - Sets the count of the radio
 * @property {function} onChange - Sets the onChange when this function is called
 */
exports.Radio = Radio;
const propTypes = exports.propTypes = {
  /**
   * Sets aria-describedBy for the input.
   */
  ariaDescribedBy: _propTypes.default.string,
  /**
   * Sets aria-label for the input.
   */
  ariaLabel: _propTypes.default.string,
  /**
   * Custom children for the Radio
   */
  children: _propTypes.default.node,
  /**
   * Sets id for the radio input
   */
  id: _propTypes.default.string,
  /**
   * Reference to the radio
   */
  inputRef: _propTypes.default.any,
  /**
   * Sets checked state of the radio
   */
  checked: _propTypes.default.bool,
  /**
   * Sets defaultChecked state of the radio
   */
  defaultChecked: _propTypes.default.bool,
  /**
   * Sets the disabled state of the radio
   */
  disabled: _propTypes.default.bool,
  /**
   * Sets if clicking on the custom children checks the radio
   */
  isFullyClickable: _propTypes.default.bool,
  /**
   * Sets name for the radio input
   */
  name: _propTypes.default.string,
  /**
   * Sets the title text of the radio
   */
  title: _propTypes.default.string,
  /**
   * Sets the count of the radio
   */
  count: _propTypes.default.number,
  /**
   * Sets the onChange when this function is called
   */
  onChange: _propTypes.default.func
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {boolean} disabled - disabled: false - default disabled state of the radio
 * @property {boolean} checked - checked: false - default checked state of the radio
 * @property {boolean} isFullyClickable - isFullyClickable: true - Sets the radio children to be fullyClickable
 */
const defaultProps = exports.defaultProps = {
  disabled: false,
  checked: false,
  isFullyClickable: true
};
Radio.propTypes = propTypes;
var _default = exports.default = Radio;